class Counter {
    wrapper: HTMLElement;
    startNum: number;
    targetNum: number;
    time: number;
    step: number;
    finished: boolean = false;
    iteration: ReturnType<typeof setInterval>;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.startNum = Number(wrapper.dataset['start']) || 1;
        this.targetNum = Number(wrapper.dataset['target']) || 0;
        this.time = Number(wrapper.dataset['time']) || 2;
    }

    init(): void {
        if (!this.targetNum || this.targetNum === this.startNum || this.finished) {
            return;
        }

        this._count();
    }

    private _count(): void {
        const duration = 1000 * this.time;
        const startTime = performance.now();

        const updateCounter = (currentTime: number): void => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const currentValue = Math.floor(this.startNum + (progress * (this.targetNum - this.startNum)));

            this.wrapper.innerText = currentValue.toLocaleString('ru-RU');

            if (progress < 1) {
                requestAnimationFrame(updateCounter);
            }
        };

        requestAnimationFrame(updateCounter);
    }
}

export default Counter;
